import { animateScroll } from 'react-scroll'

export const scrollElementToBottom = (id: string): void => {
  animateScroll.scrollToBottom({
    containerId: id,
  })
}

export const focus = (id: string): void => {
  const textarea = document.getElementById(id) as HTMLTextAreaElement
  if (textarea) {
    setTimeout(() => {
      textarea.focus()
    }, 1)
  }
}
